<template>

    <div v-if="attachments && attachments.length > 0" class="my-1 d-flex flex-row">
        <div v-for="attachment in attachments" class="ms-1 d-flex flex-row">
            <a :href="attachment.url" target="_blank">
                <img v-if="isImage(attachment)" :src="attachment.url" :width="imageWidth">
                <span v-else-if="attachment.file_type === 'application/pdf'"
                      data-bs-toggle="tooltip" data-placement="top" :title="attachment.name"><i
                        class="fas fa-file-pdf"></i> {{attachment.name}}</span>
                <span v-else>{{attachment.name}}</span>
            </a>
        </div>
    </div>

</template>

<script>
    import TableUtil from "../../utils/TableUtil";

    export default {
        name: 'AttachmentViewer',
        props: ['document', 'field', 'editable', 'tableId', 'attachments', 'imageSize'],
        mounted() {
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
        },
        computed: {
            imageWidth() {
                return this.imageSize ? this.imageSize : '200'
            }
        },
        methods: {
            isImage(attachment) {
                let tableUtil = new TableUtil()
                return tableUtil.isImage(attachment)
            }
        }
    }
</script>

<style>

</style>
